// extracted by mini-css-extract-plugin
export var maincontent = "layout-module--maincontent--a283a";